import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BASE_PATH } from "config/common";

import { IApplicationState } from "store/index";
import { IPopup, PopupType } from "store/ui/ui.types";

import ErrorPopup, {
  IErrorPopupDynamicProps,
} from "components/Popups/ErrorPopup/ErrorPopup";

const Popups = () => {
  const navigate = useNavigate();

  const popup: IPopup | null = useSelector(
    (state: IApplicationState) => state.ui.popup,
    shallowEqual
  );

  if (!popup) {
    return null;
  }

  const handleHidePopup = () => {
    navigate(BASE_PATH);
    popup.data?.hidePopup();
  };

  const data = popup.data || {};

  switch (popup.type) {
    case PopupType.ErrorPopup:
      return (
        <ErrorPopup
          {...(data as IErrorPopupDynamicProps)}
          hidePopup={handleHidePopup}
        />
      );
    default:
      return null;
  }
};

export default Popups;
